import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const SITE_URL = 'https://sandraestetica.app';
const SHARE_TEXT = 'Sandra | Estética y quiromasaje para mujeres en Paterna';

export function Share() {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  const showTemporaryNotification = (message: string) => {
    setShowNotification(true);
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: #A78991;
      color: white;
      padding: 12px 24px;
      border-radius: 999px;
      font-family: 'Barlow Semi Condensed', sans-serif;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      z-index: 1000;
      animation: fadeIn 0.3s ease;
    `;
    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.animation = 'fadeOut 0.3s ease';
      setTimeout(() => {
        document.body.removeChild(notification);
        setShowNotification(false);
      }, 300);
    }, 2000);
  };

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(SITE_URL);
      showTemporaryNotification('¡Enlace copiado!');
    } catch (error) {
      console.error('Error al copiar:', error);
      alert('No se pudo copiar el enlace. Por favor, inténtalo de nuevo.');
    }
  };

  const handleShareWhatsApp = () => {
    const encodedText = encodeURIComponent(`${SHARE_TEXT}\n${SITE_URL}`);
    window.open(`https://api.whatsapp.com/send?text=${encodedText}`, '_blank');
  };

  const handleShareWithContact = () => {
    if (!phoneNumber.trim()) {
      showTemporaryNotification('Por favor, introduce un número de teléfono');
      return;
    }

    const cleanPhone = phoneNumber.replace(/\D/g, '');
    if (cleanPhone.length < 9) {
      showTemporaryNotification('Por favor, introduce un número válido');
      return;
    }

    const encodedText = encodeURIComponent(`${SHARE_TEXT}\n${SITE_URL}`);
    window.open(`https://api.whatsapp.com/send?phone=${cleanPhone}&text=${encodedText}`, '_blank');
    setPhoneNumber('');
  };

  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center h-[50px] flex items-center justify-center">
        <h1 className="text-xl text-white">COMPARTIR</h1>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6 space-y-6">
        <div className="flex justify-center">
          <div className="p-4 bg-white rounded-lg shadow-sm">
            <QRCodeSVG 
              value={SITE_URL}
              size={200}
              level="H"
              includeMargin={true}
            />
          </div>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleCopyToClipboard}
            disabled={showNotification}
            className="w-full bg-primary text-white px-6 py-3 rounded-full hover:bg-primary/90 transition-colors disabled:opacity-50 text-center"
          >
            Copiar enlace al portapapeles
          </button>

          <button
            onClick={handleShareWhatsApp}
            className="w-full bg-primary text-white px-6 py-3 rounded-full hover:bg-primary/90 transition-colors text-center"
          >
            Compartir por WhatsApp
          </button>
        </div>

        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-2 bg-white text-gray-500">o</span>
          </div>
        </div>

        <div className="space-y-4">
          <h2 className="text-xl text-center font-semibold text-gray-700">
            Compartir a nuevo contacto
          </h2>
          
          <div className="space-y-3">
            <input
              type="tel"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Introduce número de WhatsApp"
              className="w-full px-6 py-3 rounded-full border border-gray-300 focus:border-primary focus:ring focus:ring-primary/20 focus:ring-opacity-50 text-center"
            />
            
            <button
              onClick={handleShareWithContact}
              disabled={!phoneNumber.trim()}
              className="w-full bg-primary text-white px-6 py-3 rounded-full hover:bg-primary/90 transition-colors disabled:opacity-50 text-center"
            >
              Enviar por WhatsApp
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}